import React, { FC, ReactNode } from 'react';
import './SelectField.css';
import { Field, AppEnum, ReactSelectField, ErrorMessage, SelectOptionType } from '@/Shared';
import { MultiValue, SingleValue, StylesConfig } from 'react-select';
import { CSSObjectWithLabel } from 'react-select';


interface SelectFieldProps {
	readOnly?: boolean
	label: string,
	icon?: ReactNode,
	name: string,
	options: AppEnum[],
	required?: boolean,
	value?: any,
	onChange?: (selectedOptions: MultiValue<SelectOptionType> | SingleValue<SelectOptionType>) => void,
	isMulti?: boolean;
	placeholder?: string;
	scrollParent?: HTMLElement | null
}

const SelectField: FC<SelectFieldProps> = ({
	label,
	icon,
	name,
	options,
	readOnly = false,
	required = false,
	onChange,
	value,
	isMulti = false,
	placeholder,
	scrollParent
}) => {

	
	return (
	<Field
		name={name}
		component={ReactSelectField}
		label={label}
		options={options}
		icon={icon}
		isMulti={isMulti}
		required={required}
		readOnly={readOnly}
		placeholder={placeholder}
		scrollParent={scrollParent}
		{...(onChange ? { onChange } : {})}
		errorMessage={
			(fieldName: string) =>
				(<ErrorMessage name={fieldName} component="div" className="error-message" />)
		}
	/>
);
}

export default SelectField;